import { render, staticRenderFns } from "./Simepar.vue?vue&type=template&id=f74c18bc&scoped=true"
import script from "./Simepar.vue?vue&type=script&lang=js"
export * from "./Simepar.vue?vue&type=script&lang=js"
import style0 from "./Simepar.vue?vue&type=style&index=0&id=f74c18bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74c18bc",
  null
  
)

export default component.exports